import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import AuthStore from '@app/src/common/store/AuthStore';
import { EXTERNAL_PROVIDER_CALLBACK_URL } from '@app/src/common/constants/common';
import ROUTES from '@app/src/common/constants/routeUrls';

import { Spinner, SpinnerModifiers } from '@fw-nextgen/fw-components';
import AppStore from '@app/src/common/store/AppStore';

const AuthProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    if (window.location.pathname === EXTERNAL_PROVIDER_CALLBACK_URL) {
      const params = new URLSearchParams(window.location.hash);
      const code = params.get('code') || '';
      AuthStore.getTokenFromCode(code)
        .then(() => (window.location.href = '/#/'))
        .catch(() => (window.location.href = '/#/not-authorized'));
    } else {
      const isResetPage = location.hash.includes(ROUTES.resetPasswordPage.path);
      if (isResetPage) {
        setInit(true);
      } else {
        AuthStore.checkAccess(!location.hash.endsWith(ROUTES.authPage.path))
          .then(() => AuthStore.initCurrentUser())
          .then(() => AppStore.defineUser())
          .finally(() => setInit(true))
          .catch(reason => setInit(!reason));
      }
    }
  }, []);

  return init ? (
    <>{children}</>
  ) : (
    <Spinner text={''} modifiers={[SpinnerModifiers.FULLSIZE]} />
  );
};

export default observer(AuthProvider);
